import {
  LOGIN_REQUEST,
  VERIFY_REQUEST,
  RESET_BLOCK,
  RESET_PASSWORD_REQUEST,
  GET_USER_REQUEST,
  UPDATE_USER_REQUEST,
  RESET_USER,
  LOGOUT,
  GET_PROFILE_QUESTION_REQUEST,
  ANSWER_REQUEST,
} from '../reducers/AuthReducer';

export const login = (payload) => ({ type: LOGIN_REQUEST, payload });

export const verify = (payload) => ({ type: VERIFY_REQUEST, payload });

export const reset = (block) => ({ type: RESET_BLOCK, block });

export const getUserInfo = () => ({ type: GET_USER_REQUEST });

export const passwordReset = (payload) => ({
  type: RESET_PASSWORD_REQUEST,
  payload,
});

export const updateUserInfo = (payload) => ({
  type: UPDATE_USER_REQUEST,
  payload,
});

export const resetUser = () => ({
  type: RESET_USER,
});

export const logout = () => ({
  type: LOGOUT,
});

export const getProfileQuestion = () => ({
  type: GET_PROFILE_QUESTION_REQUEST,
});

export const answerProfile = (payload) => ({
  type: ANSWER_REQUEST,
  payload,
});
